import { date } from "quasar";
import { inject } from "vue";
export const getDaysByDate = (fromDate = Date.now(), toDate = Date.now()) => {
  if (fromDate > toDate) return 0;
  return Math.round((toDate - fromDate) / (1000 * 60 * 60 * 24));
};
export const getDifferencePercentageByDate = (fromDate, toDate) => {
  fromDate = parseInt(new Date(fromDate).getTime().toFixed(0));
  toDate = parseInt(new Date(toDate).getTime().toFixed(0));
  return getDaysByDate(Date.now(), toDate) / getDaysByDate(fromDate, toDate);
};
//expecting date parameter as string
export const getRemainingDaysFromToday = (date) => {
  const date_1 = new Date();
  date_1.setTime(date_1.getTime() + date_1.getTimezoneOffset() * 60 * 1000);
  const date_2 = new Date(date);
  date_2.setTime(date_2.getTime() + date_2.getTimezoneOffset() * 60 * 1000);
  var date2_UTC = new Date(
    Date.UTC(date_2.getFullYear(), date_2.getMonth(), date_2.getDate())
  );
  var date1_UTC = new Date(
    Date.UTC(date_1.getFullYear(), date_1.getMonth(), date_1.getDate())
  );
  if (date2_UTC < date1_UTC) {
    return "0 Day, 0 Hour";
  } else {
    //--------------------------------------------------------------
    var days = date2_UTC.getDate() - date1_UTC.getDate();
    if (days < 0) {
      date2_UTC.setMonth(date2_UTC.getMonth() - 1);
      days += DaysInMonth(date2_UTC);
    }
    days = days + 1;
    //--------------------------------------------------------------
    var months = date2_UTC.getMonth() - date1_UTC.getMonth();
    if (months < 0) {
      date2_UTC.setFullYear(date2_UTC.getFullYear() - 1);
      months += 12;
    }
    //--------------------------------------------------------------
    var years = date2_UTC.getFullYear() - date1_UTC.getFullYear();
    let finalStr = [];
    if (years > 0) {
      let yearString = `${parseInt(years)}`;
      if (years > 1) yearString = yearString.concat(" years");
      else yearString = yearString.concat(" year");
      finalStr.push(yearString);
    }
    if (months > 0) {
      let monthString = `${parseInt(months)}`;
      if (months > 1) monthString = monthString.concat(" months");
      else monthString = monthString.concat(" month");
      finalStr.push(monthString);
    }
    if (days > 0) {
      let dayString = `${parseInt(days)}`;
      if (days > 1) dayString = dayString.concat(" days");
      else dayString = dayString.concat(" day");
      finalStr.push(dayString);
    }
    return finalStr.join(",");
  }
};
function DaysInMonth(date2_UTC) {
  var monthStart = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth(), 1);
  var monthEnd = new Date(date2_UTC.getFullYear(), date2_UTC.getMonth() + 1, 1);
  var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
  return monthLength;
}
export const sortListingByDate = (data) => {
  var groups = {},
    ordered = {};
  const dateConverter = (date) => {
    var dateParts = date.split("-");
    var dateObject = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
    return dateObject;
  };
  // create groups by date
  data.forEach(function (val) {
    // var date = val.time.split("T")[0];
    var date = val.created_at.split(" ")[0];
    if (date in groups) {
      groups[date].push(val);
    } else {
      groups[date] = new Array(val);
    }
  });
  // sort groups by date obj keys
  Object.keys(groups)
    .sort(function (a, b) {
      return dateConverter(b) - dateConverter(a);
    })
    .forEach(function (key) {
      ordered[key] = groups[key];
    });
  return ordered;
};
export const dateToFromNowDaily = (dt) => {
  const date_1 = new Date();
  const date_2 = new Date(dt.replace(" ", "T") + "Z");
  const fulldays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsArr = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var date2_UTC = new Date(
    Date.UTC(date_2.getFullYear(), date_2.getMonth(), date_2.getDate())
  );
  var date1_UTC = new Date(
    Date.UTC(date_1.getFullYear(), date_1.getMonth(), date_1.getDate())
  );
  var days = date1_UTC.getDate() - date2_UTC.getDate();
  var months = date1_UTC.getMonth() - date2_UTC.getMonth();
  var years = date1_UTC.getFullYear() - date2_UTC.getFullYear();
  let month = monthsArr[date_2.getMonth()];
  let date = date_2.getDate();
  if (days == 0 && years == 0 && months == 0) {
    return "Today";
  } else if (days == 1 && years == 0 && months == 0) {
    return "Yesterday";
  } else if (days == -1 && years == 0 && months == 0) {
    return "Tomorrow";
  } else if (years == 0 && months == 0 && days < -1 && days > -7) {
    return fulldays[date_2.getDay()];
  } else if (years >= 1) {
    return (
      month + " " + date + ", " + new Date(dt.replace(" ", "T")).getFullYear()
    );
  } else {
    return month + " " + date;
  }
};
export const formatedDateText = (date) => {
  if (Object.prototype.toString.call(new Date(date)) === "[object Date]") {
    let convertedDate = new Date(date.replace(" ", "T"));
    return (
      convertedDate.toLocaleString("default", { month: "long" }) +
      " " +
      convertedDate.getDate() +
      ", " +
      convertedDate.getFullYear() +
      " | " +
      convertedDate.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })
    );
  }
  return date;
};
export const dateFormatForMsg = (dt) => {
  // const date_2 = new Date(dt);
  // const intervals = [
  //   { label: "year", seconds: 31536000 },
  //   { label: "month", seconds: 2592000 },
  //   { label: "day", seconds: 86400 },
  //   { label: "hour", seconds: 3600 },
  //   { label: "minute", seconds: 60 },
  //   { label: "second", seconds: 1 },
  // ];
  // const seconds = Math.floor((Date.now() - date_2.getTime()) / 1000);
  // const interval = intervals.find((i) => i.seconds < seconds);
  // const count = Math.floor(seconds / interval.seconds);
  // return `${count} ${interval.label}${count !== 1 ? "s" : ""} ago`;
  const date_1 = new Date();
  const date_2 = new Date(dt.replace(" ", "T") + "Z");
  let year = date_1.getFullYear() - date_2.getFullYear();
  let month = date_1.getMonth() + 1 - (date_2.getMonth() + 1);
  let day = date_1.getDate() - date_2.getDate();
  // if (year > 0) {
  //   return year + " year ago";
  // } else if (month > 0) {
  //   return month + " month ago";
  // } else {
  if (day == 0) {
    return date_2.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  } else if (day == 1) {
    return "Yesterday";
  }
  // return day + " days ago";
  return (
    date_2.toLocaleString("default", { month: "short" }) +
    " " +
    date_2.getDate() +
    ", " +
    date_2.getFullYear()
  );
  // }
};
export const getDateAndFullMonthNameFromDate = (date) => {
  if (Object.prototype.toString.call(new Date(date)) === "[object Date]") {
    let convertedDate = new Date(date);
    return (
      convertedDate.getDate() +
      " " +
      convertedDate.toLocaleString("default", { month: "long" })
    );
  }
  return date;
};
export const displayTimeOnChat = (dt) => {
  const date_2 = new Date(dt.replace(" ", "T") + "Z");
  return date_2.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
};
export const getAgeFromDate = (dateString) => {
  // console.log(dateString);
  if (dateString) {
    var today = new Date();
    var birthDate = new Date(dateString.replace(" ", "T"));
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  return 0;
};
function getTimeInHoursAndMins(timeInsSeconds) {
  if (timeInsSeconds && timeInsSeconds > 0) {
    const minsTemp = timeInsSeconds / 60;
    let hours = Math.floor(minsTemp / 60);
    const mins = minsTemp % 60;
    const hoursText = "hrs";
    const minsText = "mins";
    if (hours !== 0 && mins !== 0) {
      if (mins >= 59) {
        hours += 1;
        return `${hours} ${hoursText} `;
      } else {
        return `${hours} ${hoursText} ${mins.toFixed(0)} ${minsText}`;
      }
    } else if (hours === 0 && mins !== 0) {
      return `${mins.toFixed(0)} ${minsText}`;
    } else if (hours !== 0 && mins === 0) {
      return `${hours} ${hoursText}`;
    } else {
      return `${hours} ${hoursText} ${mins.toFixed(0)} ${minsText}`;
    }
  } else {
    return "-";
  }
}
export const getRemainingDaysFromTodayForProduct = (datet) => {
  const tmp_date_1 =
    new Date().getTime() + new Date().getTimezoneOffset() * 60 * 1000;
  const tmp_date_2 = new Date(datet).getTime();
  var msDiff = tmp_date_2 - tmp_date_1;
  // console.log("--------------------------------------------------------------");
  var seconds = Math.floor(msDiff / 1000),
    minutes = Math.floor(seconds / 60),
    hours = Math.floor(minutes / 60),
    days = Math.floor(hours / 24),
    months = Math.floor(days / 30),
    years = Math.floor(days / 365);
  seconds %= 60;
  minutes %= 60;
  hours %= 24;
  days %= 30;
  months %= 12;
  // console.log("Years:", years);
  // console.log("Months:", months);
  // console.log("Days:", days);
  // console.log("Hours:", hours);
  // console.log("Minutes:", minutes);
  // console.log("Seconds:", seconds);
  return {
    months: months > 0 ? months : 0,
    days: days > 0 ? days : 0,
    hours: hours > 0 ? hours : 0,
    minutes: minutes > 0 ? minutes : 0,
  };
};
